import { render, staticRenderFns } from "./EditAddressBox.vue?vue&type=template&id=2e8036c4&scoped=true"
import script from "./EditAddressBox.vue?vue&type=script&lang=js"
export * from "./EditAddressBox.vue?vue&type=script&lang=js"
import style0 from "./EditAddressBox.vue?vue&type=style&index=0&id=2e8036c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8036c4",
  null
  
)

export default component.exports